import { render } from "./AddParametreModal.vue?vue&type=template&id=7d94e02c&ts=true"
import script from "./AddParametreModal.vue?vue&type=script&lang=ts"
export * from "./AddParametreModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__